import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import type { BookingFormData } from '@geely/shared';

export function useRescheduleDetection(resetForm: (data: BookingFormData) => void) {
  const location = useLocation();
  const [isRescheduling, setIsRescheduling] = useState(false);
  const [originalAppointmentId, setOriginalAppointmentId] = useState<string | null>(null);

  useEffect(() => {
    const rescheduleData = location.state?.rescheduleAppointment;
    if (rescheduleData) {
      setIsRescheduling(true);
      setOriginalAppointmentId(rescheduleData.id);
      resetForm({
        customerName: rescheduleData.customerName || '',
        customerPhone: rescheduleData.customerPhone || '',
        customerEmail: rescheduleData.customerEmail || '',
        customerCpf: rescheduleData.customerCpf || '',
        vehiclePlate: rescheduleData.vehiclePlate || '',
        vehicleVin: rescheduleData.vehicleVin || undefined,
        vehicleMileage: rescheduleData.vehicleMileage || undefined as any,
        modelId: rescheduleData.modelId || '',
        versionId: rescheduleData.versionId || '',
        lgpdConsent: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  return { isRescheduling, originalAppointmentId };
}
